// import React, { useState } from 'react';
// import QuestionnaireModal from '../../../Quiz/Component1/Component2/ModalQuest2';
// import { questionnaireData } from '../../../../translate/br_produto2e3.js'; 
// import { useEffect } from 'react';

// function Component2() {
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [submittedData, setSubmittedData] = useState(null);

//   const handleOpenModal = () => {
//     setSubmittedData(null); 
//     setIsModalOpen(true);
//   };

//   const handleCloseModal = () => {
//     setIsModalOpen(false);
//   };

//   const handleFormSubmit = (answersJson) => {
//     console.log("Respostas Recebidas:", answersJson);
//     setSubmittedData(answersJson);
//     alert('Respostas enviadas com sucesso! (Verifique o console)');
//     handleCloseModal(); 
//   };
//   useEffect(() => {
//     handleOpenModal();
//   }, []);
//   return (
//     <div className="App">
//       {/* <h1>Questionário Modal</h1>
//       <button onClick={handleOpenModal}>Iniciar Questionário</button> */}
      
//       <QuestionnaireModal
//         isOpen={isModalOpen}
//         onClose={handleCloseModal}
//         onSubmit={handleFormSubmit}
//         data={questionnaireData} 
//       />

//       {submittedData && (
//         <div style={{ marginTop: '30px', textAlign: 'left' }}>
//           <h2>Dados enviados com sucesso! Obrigado! </h2>
//           <pre style={{ background: '#f0f0f0', padding: '15px', borderRadius: '5px', whiteSpace: 'pre-wrap', wordBreak: 'break-all' }}>
//             {/* {JSON.stringify(submittedData, null, 2)} */}
//           </pre>
//         </div>
//       )}
//     </div>
//   );
// }

// export default Component2;


import React from 'react';
import { useTranslation } from 'react-i18next';
function Component2() {
   const {i18n } = useTranslation();

  const containerStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '300px',
    fontFamily: 'sans-serif'
  };

  const buttonContainerStyle = {
    display: 'flex',
    gap: '20px',
    marginTop: '20px'
  };

  const buttonStyle = {
    backgroundColor: '#005573', 
    color: 'white',
    padding: '12px 24px',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    fontSize: '16px',
    fontWeight: 'bold',
    textDecoration: 'none',
    transition: 'background 0.3s'
  };

  return (
    <div style={containerStyle}>
      <h2>Download de Materiais</h2>
      <p>Selecione uma das opções abaixo para baixar o arquivo Excel:</p>
      
      <div style={buttonContainerStyle}>
        
        <a 
          href={i18n.language === 'en'
    ? "/Component2.xlsx" 
    : "/Componente2.xlsx"
  }
         
          style={buttonStyle}
        >
          Download Comp 2 
        </a>
        
        <a 
              href={i18n.language === 'en'
          ? "/Component3.xlsx" 
          : "/Componente3.xlsx"
        }
          
          style={buttonStyle}
        >
          Download Comp 3
        </a>
      </div>
    </div>
  );
}

export default Component2;